import { createContext } from "react";
import { DefaultSettings, ISettingsProps } from "../Models.ts";

export const SettingsContext = createContext({ settings: DefaultSettings, setSettings: (settings: ISettingsProps) => {}});